import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { CloudinaryViewer } from 'shared/Components/VideoPlayer/CloudinaryViewer'
import { AttendActivityContainer } from 'LiveBoard/components/shared/LiveEvent/AttendActivity'
import { getActivityType, EVENT_TYPES } from 'LiveBoard/components/shared/LiveEvent/AttendActivity/helpers'

import './style.css.scss'

const PLAYER_ID = 'live-event-cld-player'
const LIVE_CLASSNAME = 'vjs-control-live'
const REPLAY_CLASSNAME = 'vjs-control-replay'

const Simulive = (props) => {
  const [videoStateClass, setVideoStateClass] = useState(props.scheduleConfig.is_enabled
    ? LIVE_CLASSNAME
    : REPLAY_CLASSNAME
  )
  const [isUserInteracted, setIsUserInteracted] = useState(false)
  const playerOptions = {
    controls: true,
    muted: true,
    autoplay: true
  }

  const videoEventMethods = {
    onLivePlay: () => setVideoStateClass(LIVE_CLASSNAME),
    onRePlay: () => setVideoStateClass(REPLAY_CLASSNAME)
  }

  return (
    <div className={`live-event-simulive-container ${videoStateClass}`}>
      <AttendActivityContainer
        themeColorHex={props.themeColorHex}
        attendActivityConfig={props.attendActivityConfig}
        boardId={props.boardId}
        activityType={getActivityType(EVENT_TYPES.simulive, props.scheduleConfig, props.videoSourceConfig)}
        hasAttendActivity={props.hasAttendActivityOverlay}
        onUserInteracted={() => { setIsUserInteracted(true) }}/>
      <CloudinaryViewer
        videoSourceConfig={props.videoSourceConfig}
        playerId={PLAYER_ID}
        playerOptions={playerOptions}
        startTimeOffset={props.startTimeOffset}
        closeVideo={props.closeVideo}
        eventMethods={videoEventMethods}
        isScheduled={true}
        isUserInteracted={isUserInteracted}
      />
    </div>
  )
}

Simulive.propTypes = {
  videoSourceConfig: PropTypes.object.isRequired,
  scheduleConfig: PropTypes.object,
  startTimeOffset: PropTypes.number,
  closeVideo: PropTypes.func,
  themeColorHex: PropTypes.string,
  boardId: PropTypes.number,
  attendActivityConfig: PropTypes.object,
  hasAttendActivityOverlay: PropTypes.bool
}

export default Simulive
